module.exports = __webpack_public_path__ + "img/沙漠球球960x1004.1b2522e4.jpg";